if (!customElements.get('model-picker')) {
  customElements.define(
    'model-picker',
    class ModelPicker extends HTMLElement {
      connectedCallback() {
        if (this.initialized) return;
        this.initialized = true;

        this.trigger = this.querySelector('[data-model-picker-trigger]');
        this.panel = this.querySelector('[data-model-picker-panel]');
        this.tabs = this.querySelectorAll('[data-model-picker-tab]');
        this.lists = this.querySelectorAll('[data-model-picker-list]');
        this.reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        this.animating = false;

        if (!this.trigger || !this.panel) return;

        this.panel.inert = true;
        this.onTriggerActivate = this.onTriggerActivate.bind(this);
        this.onDocumentClick = this.onDocumentClick.bind(this);
        this.onDocumentKeydown = this.onDocumentKeydown.bind(this);

        this.trigger.addEventListener('click', this.onTriggerActivate);
        this.tabs.forEach((tab) => {
          tab.addEventListener('click', () => this.activateTab(tab.getAttribute('data-brand')));
        });
        document.addEventListener('click', this.onDocumentClick);
        document.addEventListener('keydown', this.onDocumentKeydown);
      }

      disconnectedCallback() {
        this.clearAnimation(this.panel);
        document.removeEventListener('click', this.onDocumentClick);
        document.removeEventListener('keydown', this.onDocumentKeydown);
      }

      setOpen(open) {
        const isOpen = this.classList.contains('is-open');
        if (open === isOpen) return;

        const from = this.panel.hidden ? 0 : this.panel.getBoundingClientRect().height;

        this.classList.toggle('is-open', open);
        this.trigger.setAttribute('aria-expanded', open ? 'true' : 'false');
        this.panel.hidden = false;
        this.panel.setAttribute('aria-hidden', open ? 'false' : 'true');

        if (open) {
          this.panel.inert = false;
          this.panel.style.overflow = 'hidden';
          this.panel.style.height = 'auto';
          const to = this.panel.scrollHeight;
          this.animateHeight(this.panel, from, to, () => {
            this.panel.style.height = '';
            this.panel.style.overflow = '';
          });
        } else {
          this.animateHeight(this.panel, from, 0, () => {
            this.panel.hidden = true;
            this.panel.inert = true;
            this.panel.style.height = '';
            this.panel.style.overflow = '';
          });
        }
      }

      animateHeight(element, from, to, done) {
        this.clearAnimation(element);

        if (this.reducedMotion || from === to) {
          this.animating = false;
          done();
          return;
        }

        this.animating = true;
        element.style.overflow = 'hidden';
        element.style.height = `${from}px`;
        element.offsetHeight;
        element.style.transition = 'height 0.45s cubic-bezier(0.22, 1, 0.36, 1)';
        element.style.height = `${to}px`;

        let settled = false;
        const finish = (event) => {
          if (event && event.target !== element) return;
          if (event && event.propertyName && event.propertyName !== 'height') return;
          if (settled) return;
          settled = true;
          this.clearAnimation(element);
          element.style.transition = '';
          this.animating = false;
          done();
        };

        this._onTransitionEnd = finish;
        this._animationTimer = setTimeout(() => finish(), 500);
        element.addEventListener('transitionend', finish);
      }

      clearAnimation(element) {
        if (this._onTransitionEnd && element) {
          element.removeEventListener('transitionend', this._onTransitionEnd);
        }
        this._onTransitionEnd = null;
        if (this._animationTimer) {
          clearTimeout(this._animationTimer);
          this._animationTimer = null;
        }
      }

      activateTab(brand) {
        this.tabs.forEach((tab) => {
          const isActive = tab.getAttribute('data-brand') === brand;
          tab.classList.toggle('is-active', isActive);
          tab.setAttribute('aria-selected', isActive ? 'true' : 'false');
        });
        this.lists.forEach((list) => {
          const isActive = list.getAttribute('data-brand') === brand;
          list.classList.toggle('is-active', isActive);
          list.hidden = !isActive;
        });
      }

      onTriggerActivate(event) {
        event.preventDefault();
        this.setOpen(!this.classList.contains('is-open'));
      }

      onDocumentClick(event) {
        if (!this.contains(event.target)) this.setOpen(false);
      }

      onDocumentKeydown(event) {
        if (event.key === 'Escape' && this.classList.contains('is-open')) {
          this.setOpen(false);
          this.trigger.focus();
        }
      }
    }
  );
}
